import React, { useEffect, useRef } from "react";
import Container from "../../UI/Container/Container";
import classes from "./Message.module.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Message = (props) => {
  gsap.registerPlugin(ScrollTrigger);

  const textRef = useRef(null);

  useEffect(() => {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: textRef.current,
        start: "top 50%",
      },
    });

    timeline.to(textRef.current, { opacity: 1, duration: 1, ease: "sine.out" });
  });

  return (
    <div className={classes.Message}>
      <Container>
        <p ref={textRef}>
        Our students are truly immersed in the culture and encouraged to speak the
language, intern in the host city and live as natives rather than tourists. We
maintain our own long-established centers run by Dickinson faculty to make the
study-abroad experience truly integrated with the home campus.
And we have 30+ partner programs in 24 countries on every inhabited
continent on the planet! The world is our classroom.
        </p>
      </Container>
    </div>
  );
};

export default Message;
